import { settlementsRoutes } from './settlements/settlementsRoute'
import { withdrawRequestsRoutes } from './withdrawRequests/withdrawRequestsRoute'
import { depositRequestsRoutes } from './depositRequests/depositRequestsRoute'
import { fiatTransactionsRoutes } from './fiatTransactions/fiatTransactionsRoute'
import { refundsRoutes } from './refunds/refundsRoute'
import { walletsDirectoryRoutes } from './walletsDirectory'
import { bankAccountsDirectoryRoutes } from './bankAccountsDirectory'
import { treasuryAccountsRoutes } from './treasuryAccounts'

import type { RouteRecordRaw } from 'vue-router'

export const treasuryRoutes: RouteRecordRaw[] = [
  ...settlementsRoutes,
  ...withdrawRequestsRoutes,
  ...depositRequestsRoutes,
  ...fiatTransactionsRoutes,
  ...refundsRoutes,
  ...walletsDirectoryRoutes,
  ...bankAccountsDirectoryRoutes,
  ...treasuryAccountsRoutes,
]
